import { InputSkeleton, Skeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12" />
              <InputSkeleton className="col-span-4" />
            </FormLayout>
          </CardContainer>
          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <Skeleton className="col-span-12 h-5" />
              <Skeleton className="col-span-12 h-5" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
